import { render, staticRenderFns } from "./MotorGeneral.vue?vue&type=template&id=0af8feb7&"
import script from "./MotorGeneral.vue?vue&type=script&lang=js&"
export * from "./MotorGeneral.vue?vue&type=script&lang=js&"
import style0 from "./MotorGeneral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorGeneral.vue"
export default component.exports